<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-card class="card">
            <v-card-text>
                <h1 class="titulo mb-3">CONFIGURAR REGRA DE FURO</h1>
                <v-row class="text-center ml-5">
                    <v-col cols="12" md="6">
                        <v-switch v-model="utilizarFuroEncerramento" :label="`Utilizar furo no encerramento:`" @change="validaSwitchEncerramento"></v-switch>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-switch v-model="utilizarFuroContemplacao" :label="`Utilizar furo na contemplação:`" @change="validaSwitchContemplacao"></v-switch>
                    </v-col>
                </v-row>
                <v-row class="text-center ml-5">
                    <v-col cols="12" md="6">
                        <MoneyTextField ref="percentual_participacao" label="Furo máximo no encerramento:" class="required" :disabled="!utilizarFuroEncerramento" outlined maxlength="18" v-model="porcentagem_encerramento" :rules="[$rules.required]" :options="{ locale: 'pt-BR', suffix: '%', precision: 2, prefix: '' }" maxvalue="100" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <MoneyTextField ref="percentual_participacao" label="Furo máximo na contemplação:" class="required" :disabled="!utilizarFuroContemplacao" outlined maxlength="18" v-model="porcentagem_contemplacao" :rules="[$rules.required]" :options="{ locale: 'pt-BR', suffix: '%', precision: 2, prefix: '' }" maxvalue="100" />
                    </v-col>
                </v-row>
                <v-row class="text-center ml-5">
                    <p>LIMIAR DE FURO</p>
                </v-row>
                <v-row class="tamanhoTotal text-center ml-5 mr-5">
                    <div class="progressbar-container" :style="{ backgroundColor: '#558B2F', zIndex: '2', width: porcentagem_encerramento + '%' }"></div>
                    <div class="progressbar-container" :style="{ backgroundColor: '#FFC107', zIndex: '1', width: porcentagem_contemplacao + '%' }"></div>
                    <div class="nao_permite_venda"></div>
                </v-row>
                <br />
                <v-row class="text-center ml-5">
                    <v-col cols="4"
                    >
                        <v-row
                        >
                            <div class="legenda cor_legenda_verde"></div>
                            <p class="ml-1">Encerramento</p>
                        </v-row
                        >
                    </v-col
                    >
                    <v-col cols="4"
                    >
                        <v-row
                        >
                            <div class="legenda cor_legenda_amarelo"></div>
                            <p class="ml-1">Contemplação</p>
                        </v-row
                        >
                    </v-col
                    >
                    <v-col cols="4"
                    >
                        <v-row
                        >
                            <div class="legenda cor_legenda_vermelho"></div>
                            <p class="ml-1">Não Permite Venda</p>
                        </v-row
                        >
                    </v-col
                    >
                </v-row>
                <v-row class="text-center ml-5">
                    <v-flex class="col-8 col-md-12">
                        <Autocomplete label="+Incluir grupos na exceção:" item-text="cd_grupo" item-value="cd_grupo" placeholder="Selecione os Grupos" :items="grupos" v-model="formulario_filtro.grupo" multiple />
                    </v-flex>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-layout>
                            <v-btn class="ml-7" id="ButtonNovaRegra" style="flex: none; background-color:#00aeb7;" color="primary" @click="nova_regra()">
                                Nova Regra
                            </v-btn>
                            <v-layout v-if="!id_regra">
                                <v-btn class="ml-5" v-if="utilizarFuroEncerramento || utilizarFuroContemplacao" id="ButtonProsseguir" style="flex: none" color="primary" @click="salvar()">
                                    Salvar
                                </v-btn>
                            </v-layout>
                            <v-layout v-else>
                                <v-btn class="ml-5" id="ButtonProsseguirAtualizar" style="flex: none" color="primary" @click="atualizarRegra(id_regra)">
                                    Atualizar Regra
                                </v-btn>
                            </v-layout>
                        </v-layout>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <br />

        <v-row justify="center">
            <v-col>
                <m-text-field label="Pesquisar grupos:" v-input-filter="[$filters.alphanumeric]" v-model="formulario_filtro.cd_grupo" placeholder="Digite o código do grupo" outlined />
            </v-col>
            <v-col class="mt-7 d-flex">
                <v-btn @click="filtrar_regras(formulario_filtro.cd_grupo)" color="primary" rounded>
                    PESQUISAR
                </v-btn>
                <v-btn @click="limparFiltro()" color="secondary" class="ml-6" rounded>
                    LIMPAR PESQUISA
                </v-btn>
                <v-btn color="primary" class="ml-auto" @click="exportarExcel">
                    <v-icon left size="18">
                        mdi-file-chart
                    </v-icon>
                    SALVAR RELATÓRIO
                </v-btn>
            </v-col>
        </v-row>
        <br />
        <div v-if="pesquisar">
            <v-card v-for="(Regras, index) in loadRegras" :key="index" class="card mb-3">
                <v-card-text>
                    <h1 class="titulo mb-3" v-if="Regras.id_regra === 1">REGRA GERAL DE FURO</h1>
                    <h1 class="titulo mb-3" v-else>EXCEÇÃO DA REGRA DE FURO</h1>
                    <v-row class="text-center ml-5">
                        <v-col cols="4">
                            <v-row
                            >
                                <h3>FURO MÁXIMO NO ENCERRAMENTO {{ Regras.encerramento }}%</h3>
                            </v-row
                            >
                            <v-row
                            >
                                <h3>FURO MÁXIMO NA CONTEMPLAÇÃO {{ Regras.contemplacao }}%</h3>
                            </v-row
                            >
                        </v-col>
                    </v-row>
                    <br />
                    <v-row class="text-center ml-5" v-if="Regras.cd_grupo">
                        <v-flex class="col-8 col-md-12 alinhamento_card">
                            <v-text-field label="Grupos inclusos na exceção:" :value="Regras.cd_grupo.substring(0, Regras.cd_grupo.length - 1)" outlined disabled />
                        </v-flex>
                    </v-row>
                    <v-row class="text-center ml-5">
                        <p>LIMIAR DE FURO</p>
                    </v-row>
                    <v-row class="tamanhoTotal text-center ml-5  mr-5">
                        <div class="progressbar-container" :style="{ backgroundColor: '#558B2F', zIndex: '2', width: Regras.encerramento + '%' }"></div>
                        <div class="progressbar-container" :style="{ backgroundColor: '#FFC107', zIndex: '1', width: Regras.contemplacao + '%' }"></div>
                        <div class="nao_permite_venda"></div>
                    </v-row>
                    <br />
                    <v-row class="text-center ml-5">
                        <v-col cols="4"
                        >
                            <v-row
                            >
                                <div class="legenda cor_legenda_verde"></div>
                                <p class="ml-1">Encerramento</p>
                            </v-row
                            >
                        </v-col
                        >
                        <v-col cols="4"
                        >
                            <v-row
                            >
                                <div class="legenda cor_legenda_amarelo"></div>
                                <p class="ml-1">Contemplação</p>
                            </v-row
                            >
                        </v-col
                        >
                        <v-col cols="4"
                        >
                            <v-row
                            >
                                <div class="legenda cor_legenda_vermelho"></div>
                                <p class="ml-1">Não Permite Venda</p>
                            </v-row
                            >
                        </v-col
                        >
                    </v-row>
                    <v-row class="justify-space-between">
                        <v-col cols="2" v-if="Regras.id_regra !== 1">
                            <v-layout>
                                <v-btn id="ButtonExcluir" style="flex: none" color="secondary" @click="removerExcecao(Regras.id_regra)">
                                    Excluir
                                </v-btn>
                            </v-layout>
                        </v-col>
                        <v-col cols="2">
                            <v-layout>
                                <v-btn id="ButtonAtualizar" style="flex: none" color="primary" @click="editarRegra(Regras.id_regra)">
                                    Editar
                                </v-btn>
                            </v-layout>
                        </v-col>
                    </v-row>
                </v-card-text>
                <br />
            </v-card>
        </div>
        <div v-else>
            <v-card v-for="(Regras, index) in loadRegras" :key="index" class="card mb-3">
                <v-card-text>
                    <h1 class="titulo mb-3" v-if="Regras.id_regra === 1">REGRA GERAL DE FURO</h1>
                    <h1 class="titulo mb-3" v-else>EXCEÇÃO DA REGRA DE FURO</h1>
                    <v-row class="text-center ml-5">
                        <v-col cols="4">
                            <v-row
                            >
                                <h3>FURO MÁXIMO NO ENCERRAMENTO {{ Regras.encerramento }}%</h3>
                            </v-row
                            >
                            <v-row
                            >
                                <h3>FURO MÁXIMO NA CONTEMPLAÇÃO {{ Regras.contemplacao }}%</h3>
                            </v-row
                            >
                        </v-col>
                    </v-row>
                    <br />
                    <v-row class="text-center ml-5" v-if="Regras.cd_grupo">
                        <v-flex class="col-8 col-md-12 alinhamento_card">
                            <v-text-field label="Grupos inclusos na exceção:" :value="Regras.cd_grupo.substring(0, Regras.cd_grupo.length - 1)" outlined disabled />
                        </v-flex>
                    </v-row>
                    <v-row class="text-center ml-5">
                        <p>LIMIAR DE FURO</p>
                    </v-row>
                    <v-row class="tamanhodiv text-center ml-5  mr-5">
                        <v-col class="tamanhoTotal">
                            <div class="progressbar-container" :style="{ backgroundColor: '#558B2F', zIndex: '2', width: Regras.encerramento + '%' }"></div>
                            <div class="progressbar-container" :style="{ backgroundColor: '#FFC107', zIndex: '1', width: Regras.contemplacao + '%' }"></div>
                            <div class="nao_permite_venda"></div>
                        </v-col>
                    </v-row>
                    <br />
                    <v-row class="text-center ml-5">
                        <v-col cols="4"
                        >
                            <v-row
                            >
                                <div class="legenda cor_legenda_verde"></div>
                                <p class="ml-1">Encerramento</p>
                            </v-row
                            >
                        </v-col
                        >
                        <v-col cols="4"
                        >
                            <v-row
                            >
                                <div class="legenda cor_legenda_amarelo"></div>
                                <p class="ml-1">Contemplação</p>
                            </v-row
                            >
                        </v-col
                        >
                        <v-col cols="4"
                        >
                            <v-row
                            >
                                <div class="legenda cor_legenda_vermelho"></div>
                                <p class="ml-1">Não Permite Venda</p>
                            </v-row
                            >
                        </v-col
                        >
                    </v-row>
                    <v-row class="justify-space-between">
                        <v-col cols="2">
                            <v-layout>
                                <v-btn id="ButtonAtualizarPesquisa" class="ml-5" style="flex: none" color="primary" @click="editarRegra(Regras.id_regra)">
                                    Editar
                                </v-btn>
                                <v-btn v-if="Regras.id_regra !== 1" id="ButtonExcluirPesquisa" class="ml-5" style="flex: none" color="secondary" @click="removerExcecao(Regras.id_regra)">
                                    Excluir
                                </v-btn>
                            </v-layout>
                        </v-col>
                    </v-row>
                </v-card-text>
                <br />
            </v-card>
        </div>
    </v-container>
</template>

<script>
  import { alert, notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'
  import * as Qs from 'qs'

  const FORMULARIO_FILTRO_INITIAL_STATE = {
    grupo: [],
    cd_grupo: ''
  }
  export default {
    name: 'RegraFuro',
    data: () => ({
      utilizarFuroEncerramento: false,
      utilizarFuroContemplacao: false,
      porcentagem_encerramento: 0,
      porcentagem_contemplacao: 0,
      grupos: [],
      formulario_filtro: {
        grupo: [],
        cd_grupo: ''
      },
      pesquisar: false,
      id_regra: null,
      loadRegras: []
    }),
    computed: {
      params () {
        return {
          id_regra: this.id_regra
        }
      }
    },
    created () {
      this.loadRegraGeral()
    },
    mounted () {
      this.carregarGrupos()
    },
    methods: {
      async carregarGrupos () {
        try {
          const res = await this.$http.get('/painel/regra/grupos/autocomplete')
          this.grupos = res.data
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível buscar os grupos')
        }
      },
      async loadRegraGeral () {
        await this.$http.get('/painel/regra/carregar').then(result => {
          this.loadRegras = result.data[0].regra
          this.utilizarFuroEncerramento = false
          this.utilizarFuroContemplacao = false
        })
      },
      async salvar () {
        try {
          if (this.checkPorcentagemFinal()) {
            if (this.formulario_filtro.grupo.length > 0) {
              await this.$http
                .post('/painel/salvar_excecao', {
                  params: {
                    contemplacao: this.porcentagem_contemplacao,
                    encerramento: this.porcentagem_encerramento,
                    ativo: 1,
                    cd_grupo: this.formulario_filtro.grupo
                  }
                })
                .then(async result => {
                  if (result.data.ok) {
                    this.porcentagem_contemplacao = 0
                    this.porcentagem_encerramento = 0
                    this.formulario_filtro.grupo = []
                    this.formulario_filtro.cd_grupo = ''
                    await this.loadRegraGeral()
                    notification(AlertTypes.SUCCESS, result.data.sucesso)
                  } else {
                    notification(AlertTypes.ERROR, `${result.data.Msg_Erro}`)
                  }
                })
            } else {
              this.$http
                .post('/painel/salvar_regra', {
                  params: {
                    contemplacao: this.porcentagem_contemplacao,
                    encerramento: this.porcentagem_encerramento,
                    id_regra: 1
                  }
                })
                .then(async result => {
                  if (result.data.ok) {
                    this.porcentagem_contemplacao = 0
                    this.porcentagem_encerramento = 0
                    this.formulario_filtro = FORMULARIO_FILTRO_INITIAL_STATE
                    await this.loadRegraGeral()
                    notification(AlertTypes.SUCCESS, result.data.sucesso)
                  }
                })
            }
          }
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível salvar a regra geral')
        }
      },
      exportarExcel () {
        const filtros = this.pesquisar && this.formulario_filtro.cd_grupo
          ? { grupo: this.formulario_filtro.cd_grupo }
          : {}

        const headersExport = [
          'tipo_regra',
          'id_regra',
          'contemplacao',
          'encerramento',
          'cd_grupo'
        ]

        const headersFormatadoExport = [
          'Tipo de Regra',
          'ID da Regra',
          'Furo Máximo na Contemplação',
          'Furo Máximo no Encerramento',
          'Grupos da Exceção'
        ]

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: 'id_regra', descending: false },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/regra_furo/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      validaSwitchEncerramento () {
        this.porcentagem_encerramento = 0
      },
      validaSwitchContemplacao () {
        this.porcentagem_contemplacao = 0
      },
      nova_regra () {
        this.porcentagem_contemplacao = 0
        this.porcentagem_encerramento = 0
        this.id_regra = null
        this.formulario_filtro.grupo = []
        this.utilizarFuroEncerramento = true
        this.utilizarFuroContemplacao = true
      },
      filtrar_regras (cd_grupo) {
        if (cd_grupo !== 0) {
          try {
            this.$http
              .get('/painel/pesquisar_grupos', {
                params: {
                  grupo: cd_grupo
                }
              })
              .then(result => {
                if (!result.data[0].ok) {
                  notification(AlertTypes.ERROR, result.data[0].Msg_Erro)
                } else {
                  this.loadRegras = result.data[0].regra
                  this.pesquisar = true
                }
              })
          } catch (e) {
            notification(AlertTypes.ERROR, e, 'Não foi possível salvar a regra geral')
          }
        }
      },
      limparFiltro () {
        this.pesquisar = false
        this.formulario_filtro.cd_grupo = ''
        this.loadRegraGeral()
      },
      removerExcecao (id_regra) {
        alert({
          text: 'Tem certeza que deseja excluir a regra selecionada?\nOs dados atuais não serão salvos.',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => {
              this.$http
                .post('/painel/regra/excluir', {
                  params: {
                    id_regra: id_regra
                  }
                })
                .then(async result => {
                  if (result.data.ok) {
                    this.porcentagem_encerramento = 0
                    this.porcentagem_contemplacao = 0
                    this.formulario_filtro = FORMULARIO_FILTRO_INITIAL_STATE
                    await this.loadRegraGeral()
                    notification(AlertTypes.SUCCESS, result.data.sucesso)
                  } else {
                    notification(AlertTypes.ERROR, `${result.data.Msg_Erro}`)
                  }
                })
            }
          }
        })
      },
      async atualizarRegra (id_regra) {
        try {
          if (this.checkPorcentagemFinal()) {
            await this.$http
              .post('/painel/atualizar_regra', {
                params: {
                  contemplacao: this.porcentagem_contemplacao,
                  encerramento: this.porcentagem_encerramento,
                  ativo: 1,
                  cd_grupo: this.formulario_filtro.grupo,
                  id_regra: id_regra
                }
              })
              .then(async result => {
                if (result.data.ok) {
                  this.porcentagem_contemplacao = 0
                  this.porcentagem_encerramento = 0
                  this.formulario_filtro.grupo = []
                  this.id_regra = null
                  await this.loadRegraGeral()
                  notification(AlertTypes.SUCCESS, result.data.sucesso)
                } else {
                  notification(AlertTypes.ERROR, `${result.data.Msg_Erro}`)
                }
              })
          }
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível atualizar a exceção')
        }
      },
      editarRegra (id_regra) {
        try {
          let grupo = []
          this.$http
            .get('/painel/regra/carregarExcecao', {
              params: {
                id_regra: id_regra
              }
            })
            .then(result => {
              if (result.data[0].ok) {
                this.utilizarFuroEncerramento = !!result.data[0].Valores.encerramento
                this.utilizarFuroContemplacao = !!result.data[0].Valores.contemplacao
                this.porcentagem_contemplacao = result.data[0].Valores.contemplacao
                this.porcentagem_encerramento = result.data[0].Valores.encerramento
                // id_regra !== 1 significa que é uma regra de exceção
                if (id_regra !== 1) {
                  result.data[0].Grupos.forEach((value, index) => {
                    grupo.push(value.cd_grupo)
                    this.formulario_filtro.grupo = grupo
                  })
                  notification(AlertTypes.INFO, 'Exceção carregada com sucesso!')
                } else {
                  this.formulario_filtro = FORMULARIO_FILTRO_INITIAL_STATE
                  notification(AlertTypes.INFO, 'Regra carregada com sucesso!')
                }
                this.id_regra = result.data[0].Valores.id_regra
                this.scrollToTop()
              } else {
                notification(AlertTypes.ERROR, result.data[0].Msg_Erro)
              }
            })
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível carregar a exceção')
        }
      },
      scrollToTop () {
        window.scrollTo(0, 0)
      },
      checkPorcentagemFinal () {
        let calculo = parseFloat(this.porcentagem_contemplacao) + parseFloat(this.porcentagem_encerramento)

        if (this.porcentagem_encerramento && this.porcentagem_contemplacao && parseFloat(this.porcentagem_encerramento) > parseFloat(this.porcentagem_contemplacao)) {
          notification(AlertTypes.WARN, 'O furo no encerramento não pode ser maior do que o furo na contemplação.')
          return false
        }
        if (calculo > 100) {
          notification(AlertTypes.WARN, 'A soma dos percentuais não pode ser superior a 100%.')
          return false
        }
        return true
      }
    }
  }
</script>

<style scoped>
.nao_permite_venda {
    background-color: red;
    height: 20px;
    position: relative;
    width: 100%;
}
.tamanhoTotal {
    max-width: 100%;
    position: relative;
}
.progressbar-container {
    position: absolute;
    height: 20px;
}
.legenda {
    height: 20px;
    width: 25px;
}
.cor_legenda_verde {
    background-color: #558b2f;
}
.cor_legenda_amarelo {
    background-color: #ffc107;
}
.cor_legenda_vermelho {
    background-color: red;
}
.alinhamento_card {
    padding-left: 0px !important;
}
</style>
